import React, { useEffect, useState } from "react";

import API from "../../../services/api";

import "./NotificationSettings.css";

function NotificationSettings() {

    const [settings, setSettings] = useState({

        newOrders: true,

        orderUpdates: true,

        earnings: true,

        incentives: true,

        promotions: false,

        sound: true,

        vibration: true,

    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {

        fetchSettings();

    }, []);

    const fetchSettings = async () => {

        try {

            const response = await API.get(

                "/delivery/notification-settings"

            );

            if (response.data.success) {

                setSettings(response.data.settings);

            }

        }

        catch (error) {

            console.log(error);

        }

    };

    const handleToggle = (key) => {

        setSettings({

            ...settings,

            [key]: !settings[key],

        });

    };

    const saveSettings = async () => {

        try {

            setLoading(true);

            const response = await API.put(

                "/delivery/notification-settings",

                settings

            );

            alert(response.data.message);

        }

        catch (error) {

            console.log(error);

        }

        finally {

            setLoading(false);

        }

    };

    return (

        <div className="notification-settings-page">

            <h1>

                Notification Settings

            </h1>

            <p>

                Manage how HomeFoods notifies you.

            </p>

            <div className="settings-card">

                <SettingRow

                    title="New Delivery Requests"

                    value={settings.newOrders}

                    onChange={()=>

                        handleToggle("newOrders")

                    }

                />

                <SettingRow

                    title="Order Updates"

                    value={settings.orderUpdates}

                    onChange={()=>

                        handleToggle("orderUpdates")

                    }

                />

                <SettingRow

                    title="Earnings"

                    value={settings.earnings}

                    onChange={()=>

                        handleToggle("earnings")

                    }

                />

                <SettingRow

                    title="Incentives"

                    value={settings.incentives}

                    onChange={()=>

                        handleToggle("incentives")

                    }

                />

                <SettingRow

                    title="Promotions"

                    value={settings.promotions}

                    onChange={()=>

                        handleToggle("promotions")

                    }

                />

                <SettingRow

                    title="Sound"

                    value={settings.sound}

                    onChange={()=>

                        handleToggle("sound")

                    }

                />

                <SettingRow

                    title="Vibration"

                    value={settings.vibration}

                    onChange={()=>

                        handleToggle("vibration")

                    }

                />

            </div>

            <button

                className="save-settings-btn"

                onClick={saveSettings}

            >

                {

                    loading

                    ?

                    "Saving..."

                    :

                    "Save Settings"

                }

            </button>

        </div>

    );

}

function SettingRow({

    title,

    value,

    onChange,

}) {

    return (

        <div className="setting-row">

            <span>

                {title}

            </span>

            <label className="switch">

                <input

                    type="checkbox"

                    checked={value}

                    onChange={onChange}

                />

                <span className="slider"></span>

            </label>

        </div>

    );

}

export default NotificationSettings;